<template>
  <div class="subject_wrap"  v-for="(vo, idx) in parseHtmlList" :key="idx">
    <div class="info_tip" v-if="vo.value.keyPadList.length > 0 && idx == 0">
      <p>
        괄호[&nbsp;&nbsp;]문구 터치 후&nbsp;<strong>직접 문자 입력</strong
        >하세요.<i class="ico_typing"></i
        ><i class="ico_tip" @click="guidPopup('typing')"></i>
      </p>
    </div>

    <p class="tit">{{ vo.value.title }}</p>
    <p class="view_subject">
     <template v-for="(vo1, idx1) in vo.value.keyPadList">
        <p v-if="vo1.isTitle" :key="idx1 + '_1'" class="tit">
          {{ vo1.text }}<br />
        </p>
        <template v-else-if="vo1.isAddInp"
          >[<span
            class="comment_wrap"
            :class="vo1.focused ? 'active' : ''"
            :key="idx1"
            ><label :for="'check_' + ctnsKdCd + '_' + idx1">{{
              vo1.labelText

            }}</label
            ><input
              type="text"
              :id="'check_' + ctnsKdCd + '_' + idx1"
              :ref="(el) => (vo1.addInpEl = el)"
              :maxlength="vo1.text.length + 1"
              @focus="vo1.focused = true"
              @blur="vo1.focused = false"
              @keyup="keyupEv(vo, $event, idx1, parseHtmlList)"
              :class="vo1.error ? 'error' : ''"/></span
          >]</template
        >
        <span
          v-else
          v-html="vo1.text.replace(/\n/gi, '<br />')"
          :key="idx1"
        ></span>
      </template>
    </p>
    <div
        v-if="(vo.value.keyPadList.length > 0) & (vo.value.swipeList.length > 0)"

    >
      <br />
    </div>
    <div class="info_tip" v-if="vo.value.swipeList.length > 0">
      <p>
        괄호[&nbsp;&nbsp;]문구 터치 후&nbsp;<strong>드래그</strong>하세요.<i
          class="ico_swipe"
        ></i
        ><i class="ico_tip" @click="guidPopup('swipe')"></i>
      </p>
    </div>
    <p class="view_subject type2">
      <template v-for="(vo, idx) in vo.value.swipeList">
        <p v-if="vo.isTitle" :key="idx + '_1'" class="tit">
          {{ vo.text }}<br />
        </p>
        <template v-else-if="vo.isAddInp">
          <div
            class="placeholder_box"
            :key="idx + '_2'"
            :class="vo.isFinished ? 'finish' : vo.focused ? 'focus' : ''"
            v-touch:drag="touchEv(idx)"
            @click="vo.focused = true"
            :ref="(el) => (vo.addInpEl = el)"
          >
            <div class="action" :style="'width:' + vo.rate + '%'"></div>
            <label for="placeholder0">{{ vo.text }}</label>
          </div>
        </template>
        <span
          v-else
          v-html="vo.text.replace(/\n/gi, '<br />')"
          :key="idx + '_3'"
        ></span>
      </template>
    </p>
  </div>
</template>

<script>
import { ref, inject } from 'vue'
import util from '@/common/util'
import useDialog from '@/common/dialog'

export default {
  name: 'AddInp',
  props: {
    contents: Object,
    ctnsKdCd: String,
  },
  setup(props, { emit }) {
    const dialog = useDialog(inject('$vfm'))
    const parseHtmlList = [];

    function makeAddInpData(strList) {
      let addInpData = _.reduce(
        strList,
        function(list, data) {
          if (util.isEmpty(data.hgrkMenu) && data.trmLv == '1') {
            list = {
              title: data.wrdCon,
              menuLv: data.menuLv,
              trmLv: data.trmLv,
              keyPad: [],
              swipe: [],
              children: [],
            }
          } else {
            let target = ''
            if (data.trmLv == '2') {
              target = list
            } else if (data.trmLv == '3') {
              target = _.find(list.children, (e) => e.menuLv == data.hgrkMenu)
            }

            if (data.indiYn == '1') {
              let inpKey = data.wrdCon.indexOf('$') != -1 ? 'keyPad' : 'swipe'
              target[inpKey] = _.union(
                target[inpKey],
                parseData(data.wrdCon, inpKey == 'keyPad' ? '$' : '#')
              )
            } else if (data.indiYn == '2') {
              target['children'].push({
                subTitle: data.wrdCon,
                menuLv: data.menuLv,
                trmLv: data.trmLv,
                keyPad: [],
                swipe: [],
              })
            }
          }
          return list
        },
        {}
      )

      let data = {
        title: '',
        keyPadList: [],
        swipeList: [],
      }

      data.title = addInpData.title

      data.keyPadList = _.union(data.keyPadList, addInpData.keyPad)
      _.each(addInpData.children, (d) => {
        if (d.keyPad.length > 0) {
          data.keyPadList.push({
            isTitle: true,
            text: d.subTitle,
          })
        }
        data.keyPadList = _.union(data.keyPadList, d.keyPad)
      })

      data.swipeList = _.union(data.swipeList, addInpData.swipe)
      _.each(addInpData.children, (d) => {
        if (d.swipe.length > 0) {
          data.swipeList.push({
            isTitle: true,
            text: d.subTitle,
          })
        }
        data.swipeList = _.union(data.swipeList, d.swipe)
      })

      return data
    }

    function parseData(str, delimiter) {
      let list = []

      let stIdx = 0
      let edIdx = str.indexOf(delimiter)
      let addInpFlag = false
      if (edIdx == -1) {
        addList(list, str + '\n')
        return list
      } else if (edIdx != 0) {
        addList(list, str.substring(stIdx, edIdx))
      }

      stIdx = edIdx

      while (str.indexOf(delimiter, edIdx + 1) != -1) {
        addInpFlag = !addInpFlag
        edIdx = str.indexOf(delimiter, edIdx + 1)

        if (!addInpFlag && stIdx == edIdx - 1) {
          addList(list, ' ')
          stIdx = edIdx
          continue
        } else {
          addList(list, str.substring(stIdx + 1, edIdx), addInpFlag, delimiter)
          stIdx = edIdx
        }
      }

      if (str.length - 1 != edIdx) {
        addList(list, str.substring(edIdx + 1) + '\n')
      } else {
        addList(list, '\n')
      }

      return list
    }

    function addList(list, str, addInpFlag, delimiter) {
      if (delimiter == '$') {
        list.push({
          text: str,
          labelText: str,
          isAddInp: addInpFlag,
          focused: false,
          isFinished: false,
        })
      } else {
        list.push({
          text: str,
          labelText: str,
          isAddInp: addInpFlag,
          rate: 100,
          focused: false,
          isFinished: false,
        })
      }
    }

    const guidPopup = (type) => {
      dialog.lyorPop(
        'common/dialog/ImagePop.vue',
        { image: type },
        { content: 'pop_agree' }
      )
    }
    let contentsList = _.groupBy(props.contents, 'dcmKdCd')
    let contentsArrayList = _.toArray(contentsList)
    

    _.each(contentsArrayList, (v) => {
      const parseHtml = ref('')
      parseHtml.value = makeAddInpData(v)
      parseHtmlList.push(parseHtml)
    })

    let state = false
    let isDetecting = false
    // const rate = ref(100)
    // const sliderAttr = computed(() =>
    //     `width: ${rate.value}%`
    // )
    // const placeHolderClass = ref("")
    // const placeHolderClass2 = ref("")

    // const pasLet = ref("알릴의무")

    // const clickEv = idx => {
    //     // if(!state){
    //     //     state = false
    //         parseHtml.value[idx].focused = true
    //     // }
    // }

    const touchEv = (idx) => {
      return function(e) {
        if (parseHtml.value.swipeList[idx].isFinished) return
        let pageX = e.touches[0].pageX
        let offsetLeft = e.target.offsetParent.offsetLeft
        let offsetWidth = e.target.offsetParent.offsetWidth

        // if(!state){
        if (pageX < offsetLeft + 40) isDetecting = true
        if (isDetecting) {
          parseHtml.value.swipeList[idx].rate =
            100 - ((pageX - offsetLeft) / offsetWidth) * 100
          if (pageX > offsetLeft + offsetWidth) {
            parseHtml.value.swipeList[idx].rate = 0
            // state = true
            isDetecting = false
            parseHtml.value.swipeList[idx].isFinished = true

            let next = _.find(
              parseHtml.value.swipeList,
              (e) => e.isAddInp == true,
              idx + 1
            )
            if (!util.isNull(next)) {
              next.focused = true
            }
            // parseHtml.value[idx].placeHolderClass = "finish"
          }
        }
        // }
      }
    }

     const keyupEv = (parseHtml, e, idx, parseHtmlList) => {
      if (parseHtml.value.keyPadList[idx].text == e.srcElement.value) {
        completeEvent(parseHtml, idx, parseHtmlList)
      } else {
        if (
          parseHtml.value.keyPadList[idx].text.indexOf(e.srcElement.value) != -1
        ) {
          parseHtml.value.keyPadList[idx].error = false
        } else {
          parseHtml.value.keyPadList[idx].error = true
          if (
            e.srcElement.value.length >
            parseHtml.value.keyPadList[idx].text.length
          ) {
            parseHtml.value.keyPadList[idx].labelText = e.srcElement.value
          } else {
            parseHtml.value.keyPadList[idx].labelText =
              parseHtml.value.keyPadList[idx].text
          }
        }

        parseHtml.value.keyPadList[idx].focused = true
        parseHtml.value.keyPadList[idx].isFinished = false
      }
    }


     const completeEvent = (parseHtml, idx, parseHtmlList) => {
      parseHtml.value.keyPadList[idx].labelText =
        parseHtml.value.keyPadList[idx].text
      parseHtml.value.keyPadList[idx].error = false
      parseHtml.value.keyPadList[idx].focused = false
      parseHtml.value.keyPadList[idx].isFinished = true

      let next = ''
      _.each(parseHtmlList, (d) => {
        next = _.find(
          d.value.keyPadList,
          (e) => e.isAddInp == true && e.isFinished == false
        )
        if (!util.isNull(next)) {
          return false
        }
      })

      if (!util.isNull(next)) {
        next.addInpEl.focus()
      } else {
        parseHtml.value.keyPadList[idx].addInpEl.blur()
        checkKeyPads(parseHtml)
      }
    }


    const checkKeyPads = (parseHtml) => {
      let next = _.find(
        parseHtml.value.keyPadList,
        (e) => e.isAddInp == true && e.isFinished == false
      )

      if (!util.isNull(next)) {
        next.addInpEl.focus()
      } else {
        emit('allKeyPadFinished')
      }
    }

    return {
      parseHtmlList,
      // state,
      // isDetecting,
      // rate,
      // sliderAttr,
      // placeHolderClass,
      // clickEv,
      touchEv,
      keyupEv,
      guidPopup,
      completeEvent,
    }
  },
}
</script>

<style scoped>
.comment_wrap:not(.active) label {
  font-size: 1rem;
  transform: scale(0.875);
}

.comment_wrap:not(.active) input[type='text'] {
  font-size: 1rem;
  transform: scale(0.875);
}

.comment_wrap input[type='text'].error {
  color: #ee3823;
}
</style>
